var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { stateColor, superBoxStyle, } from '@vital-ui/react-utils';
export var Hint = styled('div').attrs(function (props) { return ({
    className: cn('vital__hint', props.className),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block !important;\n  padding-top: 0.4rem;\n  font-size: 0.8rem;\n  line-height: 1.42857;\n  padding-left: 1px;\n  white-space: normal;\n  color: ", ";\n  ", ";\n"], ["\n  display: block !important;\n  padding-top: 0.4rem;\n  font-size: 0.8rem;\n  line-height: 1.42857;\n  padding-left: 1px;\n  white-space: normal;\n  color: ", ";\n  ", ";\n"])), function (props) { return stateColor(props, props.theme.form.hint.color); }, superBoxStyle);
Hint.defaultProps = {
    theme: defaultTheme,
    alarm: false,
    warning: false,
    success: false,
};
var templateObject_1;
//# sourceMappingURL=Hint.js.map